import request from '@/util/request';
import qs from 'qs';
//房产树一级节点
export const getHealthDataPage = (params, options) =>
  request.get(
    '/api/v4ward/nursing/health/manage/getHealthDataPage',
    Object.assign({}, options, {
      params
    })
  );
  export const getHealthExamPage = (params, options) =>
  request.get(
    '/api/v4ward/nursing/health/manage/getHealthExamPage',
    Object.assign({}, options, {
      params
    })
  );

  export const getHealthVisitPage = (params, options) =>
  request.get(
    '/api/v4ward/nursing/health/manage/getHealthVisitPage',
    Object.assign({}, options, {
      params
    })
  );
  export const getHealthAlarmPage = (params, options) =>
  request.get(
    '/api/v4ward/nursing/health/manage/getHealthAlarmPage',
    Object.assign({}, options, {
      params
    })
  );

  export const getHealthAssessmen = (params, options) =>
  request.get(
    '/api/v4ward/nursing/health/manage/getHealthAssessment',
    Object.assign({}, options, {
      params
    })
  );

  export const getHealthFollowPage = (params, options) =>
  request.get(
    '/api/v4ward/nursing/health/manage/getHealthFollowPage',
    Object.assign({}, options, {
      params
    })
  );
export const saveHealthExam = (params, options) =>
  request.post('/api/v4ward/nursing/health/manage/saveHealthExam', params, options);

  export const updateHealthExam = (params, options) =>
  request.post('/api/v4ward/nursing/health/manage/updateHealthExam', params, options);

  export const removeHealthExam = (id) =>
  request.post('/api/v4ward/nursing/health/manage/removeHealthExam?ids='+id);

  export const saveHealthVisit = (params, options) =>
  request.post('/api/v4ward/nursing/health/manage/saveHealthVisit', params, options);

  export const updateHealthVisit = (params, options) =>
  request.post('/api/v4ward/nursing/health/manage/updateHealthVisit', params, options);

  export const removeHealthVisit = (id) =>
  request.post('/api/v4ward/nursing/health/manage/removeHealthVisit?ids='+id);

  export const submitAssessment = (params, options) =>
  request.post('/api/v4ward/nursing/health/manage/submitAssessment', params, options);


  export const saveHealthFollow = (params, options) =>
  request.post('/api/v4ward/nursing/health/manage/saveHealthFollow', params, options);


  export const updateHealthFollow = (params, options) =>
  request.post('/api/v4ward/nursing/health/manage/updateHealthFollow', params, options);


  export const removeHealthFollow = (id) =>
  request.post('/api/v4ward/nursing/health/manage/removeHealthFollow?ids='+id);


export const smartcardlogout = (params, options) =>
request.post('/api/v4ward/nursinghome/smart/card/logout',qs.stringify(params), options);
